import { userConstants } from '../constants'
import { ClientService, StorageService, MuvicardService } from '../services'
import { parseJwt } from '@helpers'
import { RoleConstants } from '../constants'

/**
 * Authenticates an user into application
 * @param {object} user The application user
 */
const login = user => async dispatch => {
	const { role } = parseJwt(user.accessToken)

	dispatch(setAccessToken(user.accessToken))

	let { data, success: muvicardSuccess } = await MuvicardService.GetCardInfo()

	if (muvicardSuccess) {
		user = { ...user, muvicardData: data }
	}

	let isRequester = role.some(userRole => userRole === RoleConstants.Requester)

	const userData = { ...user, roles: role, isRequester }

	StorageService.authentication.user.set(userData)

	return dispatch({
		type: userConstants.LOGIN,
		user: userData
	})
}

const setAccessToken = accessToken => {
	return {
		type: userConstants.SET_ACCESS_TOKEN,
		payload: accessToken
	}
}

/**
 * Unauthenticates the current user into application
 */
const logout = () => {
	StorageService.authentication.user.remove()
	return {
		type: userConstants.LOGOUT
	}
}

const updatePlan = () => async dispatch => {
	ClientService.getSubscription()
		.then(({ data: plan, success }) => {
			return dispatch({
				type: userConstants.UPDATE_PLAN,
				payload: success ? plan : null
			})
		})
		.catch(() => dispatch({ type: userConstants.UPDATE_PLAN, payload: null }))
}

export const userActions = {
	login,
	logout,
	updatePlan,
	setAccessToken
}
